const baseUrl = process.env.REACT_APP_BASEAPI_URL;

export default baseUrl;
